// ----------------------------------------------------------------------------
// Component: Product Recommendations
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/card/card';


// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const RECOMMENDATIONS_SELECTOR = '.product-recommendations';


// -------------------------------------
// Helpers
// -------------------------------------

function loadRecommendations() {
    const recommendations = document.querySelector(RECOMMENDATIONS_SELECTOR);

    if (recommendations === null) { return; }

    const productID   = recommendations.dataset.productId;
    const limit       = recommendations.dataset.limit;
    const requestUrl  = window.Shopify.routes.root + "recommendations/products?section_id=product-recommendations&limit=" + limit + "&product_id=" + productID;
    const request     = new XMLHttpRequest();

    request.open("GET", requestUrl);
    request.onload = function() {
        if (request.status >= 200 && request.status < 300) {
            const container = document.createElement("div");

            container.innerHTML = request.response;
            recommendations.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
        }
    }

    request.send();
}


// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function() {
    loadRecommendations();
});
